import React from 'react';
import { Col, Row } from 'components/Core/Grid';
import Cookies from 'js-cookie';
import { STGlyphTertiary } from 'components/Brand/Logos/STGlyph';
import GoogleIcon from 'components/Brand/Icons/GoogleIcon';
import FacebookRound from 'components/Brand/Icons/FacebookRound';
import Button from 'components/Core/Button';

const LoginOptions = ({ onClick }) => (
  <Row gutter={15}>
    <Col md={8}>
      <Button
        to="https://go.servicetitan.com/auth/newauth/login?sttoolbox=1&return=https://www.servicetitan.com/toolbox"
        type="white"
        outlined
        width="100%"
        shadow={true}
        target="_self"
        onClick={() => {
          Cookies.set('redirect', document.location.pathname);
        }}
      >
        <STGlyphTertiary width="32" height="32" />
      </Button>
    </Col>
    <Col md={8}>
      <Button
        type="white"
        outlined
        width="100%"
        shadow={true}
        onClick={() => onClick('0oa4wdg1wo5vXaDRu5d6')}
      >
        <GoogleIcon className="google" width="32" height="32" />
      </Button>
    </Col>
    <Col md={8}>
      <Button
        type="white"
        outlined
        width="100%"
        shadow={true}
        onClick={() => onClick('0oa4txkqyf8ba1ytF5d6')}
      >
        <FacebookRound width="32" height="32" />
      </Button>
    </Col>
  </Row>
);

export default LoginOptions;
